import { render, staticRenderFns } from "./DriverRegisteredIcon.vue?vue&type=template&id=dbd7f2ca&"
import script from "./DriverRegisteredIcon.vue?vue&type=script&lang=js&"
export * from "./DriverRegisteredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports